export default "https://assets-v2.scaler.com/packs/files/santhosh.eb0f55.webp";